import React, { Fragment, useEffect, useContext, useState } from 'react';

import { Typography, Row, Col } from 'antd';
import axios from 'axios';
import { AuthContext } from '../context/Auth';
import './css/styles.css';
import { CircularProgress } from '@material-ui/core';
import { API_URL } from '../context/constants';

const {Title}=Typography


const Rutas = () => {
  // eslint-disable-next-line
    const [data,setData]=useState({});
    const {token,currentUser}=useContext(AuthContext)
    const [loading,setLoading]=useState(false);
    const [route,setRoute]=useState(null)
    useEffect(() => {    
        const getUserData=async()=>{
          if (!token)
          return
          setLoading(true)
          const r=await axios.get(`${API_URL}/profile/${currentUser.uid}`,{
            headers:{
              token
            }
          });
          setData(r.data)
          if(r.data.ruta!==""&&r.data.ruta){
            
            const ruta=await axios.get(`${API_URL}/rutas/${r.data.ruta}`,{
              headers:{
                token
              }
            })
            if(ruta.data.ruta){
              if(ruta.data.ruta.inicioServicio&&ruta.data.ruta.inicioServicio!==''){
                setRoute(ruta.data.ruta);
                setLoading(false);
                return;
              }
              else{
                setRoute(null);
                setLoading(false);
                return;
              }
            }else{
              setRoute(null);
              setLoading(false);
              return;
            }
            
          }else{
            setRoute(null);
          }
          // setRoute(null);
          setLoading(false);
        }
        getUserData();
        // eslint-disable-next-line
      }, [token])
    return !token||loading?<CircularProgress/>:
    route===null?
    <Fragment>
      <div style={{marginRight:'auto',marginLeft:'auto',paddingTop:'50px',marginBottom:'auto',maxWidth:'800px'}}>
        <Title className="title"  style={{color: '#2B7BBC',fontWeight:200}} >
              Aún no tienes asignada ninguna ruta
        </Title>
      </div>
    </Fragment>
    :
    <Fragment>
      <div style={{marginRight:'auto',marginLeft:'auto',paddingTop:'50px',marginBottom:'auto',maxWidth:'800px'}}>
      <Title className="title"  style={{color: '#2B7BBC',fontWeight:200}} >
            Tu Ruta Asignada
      </Title>
           <Typography.Title level={3}>
                    {route.nombreRuta}
            </Typography.Title>
              <Row gutter={30}>
                <Col span={14}  xs={24} sm={24}  md={14}  lg={14}>
                  <img  style={{width:'100%'}} src={route.imagen} alt="Imagen de la ruta"/> 
                </Col>
                <Col span={10} xs={24} sm={24} md={10}  lg={10}>
                <Typography.Title level={3}>
                        Inicio de Servicio:<br/> {route.inicioServicio}
                    </Typography.Title>
                <Typography.Title level={2}>
                        Inicio:{route.inicioRuta} {route.horaInicio}
                    </Typography.Title>
                    {route.paradas?
                    <div>
                        <Typography.Title level={2}>
                        Paradas:
                    </Typography.Title >
                    <ul className='lista'>
                    {route.paradas.map(item=>
                        <li className="lista-item" key={item.parada}>Calle Parada:{item.parada}  -  {item.horaParada}</li>
                      )}
                      </ul>
                    </div>:
                    <div/>
                    }
                  <Typography.Title  style={{marginTop:30}}  level={3}>
                    Fin:{route.finRuta} {route.horaFin}
                  </Typography.Title>
                </Col>
              </Row>
      </div>
    </Fragment> 
}

export default Rutas;